// export const adminUrl = "http://122.165.52.124:4000/api/v1/"; 
// export const adminUrl = "http://localhost:5000/api/v1/";
export const adminUrl = "https://goldstakebackend.cygnusa.in/api/v1/";

// export const adminUrl = "https://api.gorex.in/api/v1/"; 
// "homepage": "https://energy-dev.gorex.in/",


export const loginUrl = "";

